import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from "react-transition-group";
import "../../assets/css/transition.css";
import basebg from "../../assets/images/resource/base.png";
import service from "../../assets/images/resource/simulator.png";
import prodome3 from "../../assets/images/resource/prodome3.png";
import { ROUTE } from '../../Common/constant';
import FooterOne from '../Footer/FooterOne';
import Header from '../Header/HeaderOne';
import { pageTitle } from '../PageTitle';
import ProductFour from './ProductFour';
import ProductOne from './ProductOne';
import ProductThree from './ProductThree';
import ProductTwo from './ProductTwo';

const Products = () => {
    pageTitle('Products');

    const { pathname } = useLocation()
    let endpoint = pathname.split("/")
    endpoint = endpoint[endpoint.length - 1]

    const isProductBase = pathname === ROUTE.PRODUCTS.BASE_URL

    const products = [
        { id: "simulator", title: 'Simulator', url: ROUTE.PRODUCTS.DETAIL, content: <ProductOne /> },
        { id: "vr-maintenance", title: 'VR Maintenance', url: ROUTE.PRODUCTS.DETAIL, content: <ProductTwo /> },
        { id: "fleet-management-system", title: 'Fleet Management System', url: ROUTE.PRODUCTS.DETAIL, content: <ProductThree /> },
        { id: "data-capture-and-analytics", title: 'Data Capture & Analytics', url: ROUTE.PRODUCTS.DETAIL, content: <ProductFour /> },
    ];

    const renderServices = () => {
        return products.map((product) => (
            <li key={product.id}>
                <Link to={product.url.replace(":id", product.id)} className={product.url.replace(":id", product.id) === pathname ? 'active' : ''}>{product.title}</Link>
            </li>
        ));
    };

    const renderContent = () => {
        for (const product of products) {
            if (product.id === endpoint) return product.content
        }
    }

    return (
        <>
            <Header />
            <div className="service__details p_relative see__pad">
                <div className="auto-container">
                    <div className="row">
                        <div className="col-xl-4 col-lg-6 col-md-12">
                            <div className="service__details__left">
                                <div className="sidebar__widget">
                                    <div className="all__service">
                                        <h4>All Products</h4>
                                    </div>
                                    <ul className="service__details__1__cat">
                                        {renderServices()}
                                    </ul>
                                </div>
                                <div className=" sidebar__widget_network" style={{ backgroundImage: `url(${basebg})` }}>
                                    <h3>Contact Us For Any Require</h3>
                                    <div className="services__icon">
                                        <i className="icon-19"></i>
                                    </div>
                                    <p>Need help?  Call us:</p>
                                    <h4> <Link to="tell:622139720881">+62 21 3972 0881</Link></h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-8 col-lg-12 col-md-12">
                            <div className="service__right">
                                <TransitionGroup>
                                    <CSSTransition
                                        key={endpoint}
                                        timeout={500}
                                        classNames={"fade"}
                                    >
                                        {isProductBase ?
                                            <>
                                                <figure>
                                                    <img src={service} alt="" />
                                                </figure>
                                                <h2><span>Indonesia's</span> Pride Mining Simulator</h2>
                                                <p>VSIM is an Indonesian product simulator that has spread to various countries in Asia. VSIM offers various types of simulators for the purposes of increasing human resource capabilities in the fields of industry, education, transportation, health services, mining and energy, and the military.</p>
                                                <div className="row">
                                                    <div className="col-lg-6 col-md-12">
                                                        <li> <Link to="#">Mobile Design</Link></li>
                                                    </div>
                                                    <div className="col-lg-6 col-md-12">
                                                        <li> <Link to="#">Dynamic Terrain</Link></li>
                                                    </div>
                                                    <div className="col-lg-6 col-md-12">
                                                        <li> <Link to="#">Dynamic Event</Link></li>
                                                    </div>
                                                    <div className="col-lg-6 col-md-12">
                                                        <li> <Link to="#">Modular Kit</Link></li>
                                                    </div>
                                                </div>
                                                <p>
                                                    Improving safety, productivity, profitability in the mining industry is the main thing. On the other hand, it is required to be efficient in production costs. VSIM provides efficient, safe and low-cost training for operators to achieve these goals so that they can optimize the company's resources.
                                                </p>
                                                <p>&nbsp;</p>
                                                <p>
                                                    The ability to train operators to react well in potentially life-threatening situations is invaluable in the world of mining. Many dangerous situations rarely occur, so training operators to understand proper protocols in a safe environment is critical for mining operations to ensure operators are better prepared and able to react with confidence.
                                                </p>
                                                <p>&nbsp;</p>
                                                <figure>
                                                    <img src={prodome3} alt="" />
                                                </figure>
                                            </>
                                            :
                                            renderContent()
                                        }
                                    </CSSTransition>
                                </TransitionGroup>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ marginTop: "128px" }} />
            <FooterOne />
        </>
    );
}

export default Products